// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"231":"2679eedf","375":"5a12ab9d","527":"ee6d9c28","937":"37181276","951":"6590fc6e"}[chunkId] + ".chunk.js";
};